(function(){
/* MasalSensin Wizard — 4-step flow (Kahraman / Cinsiyet / Fotoğraflar+Cloudinary / Hazırlayan+İlişki / Not)
   Yaş adımı kaldırıldı. Fotoğraflar Cloudinary'ye (unsigned preset) yüklenir, secure_url properties'e yazılır. */

var CLOUDINARY_CLOUD='dd7r5p0nd';
var CLOUDINARY_PRESET='masalsensin_customer_photos';

var step=0,gender='',photos=[],photoUrls=[],iliski='',variantId=0;
var iliskiSel=[], hazAuto='';
var KW_POSS={'Anne':'Annen','Baba':'Baban','Anneanne':'Anneannen','Babaanne':'Babaannen','Dede':'Deden','Nine':'Ninen','Teyze':'Teyzen','Hala':'Halan','Amca':'Amcan','Dayı':'Dayın','Yenge':'Yengen','Enişte':'Enişten','Ağabey':'Ağabeyin','Abla':'Ablan','Arkadaş':'Arkadaşın'};
var uploadingCount=0;
var editLineKey=null;  // set when user arrived via "Bilgileri düzenle" from cart
var overlay=document.getElementById('ms-wiz-overlay');
if(!overlay)return;
var steps=overlay.querySelectorAll('.kw-step');
var dots=overlay.querySelectorAll('.kw-dot');
var LAST_STEP=3;

// Get variant ID from product page
var form=document.querySelector('form[action*="/cart/add"]');
if(form){
  var vid=form.querySelector('[name="id"]');
  if(vid)variantId=parseInt(vid.value);
}

// Edit mode: if we arrived from cart with ?edit_cart=1, hydrate form from localStorage
try {
  if (location.search.indexOf('edit_cart=1') >= 0) {
    var raw = localStorage.getItem('ms_wiz_edit_state');
    if (raw) {
      var saved = JSON.parse(raw);
      if (saved && saved.ts && (Date.now() - saved.ts) < 3600000) {
        editLineKey = saved.lineKey;
        if (saved.variantId) variantId = saved.variantId;
        var hydrate = function() {
          var nameInput = document.getElementById('kw-name');
          var hazInput  = document.getElementById('kw-hazirlayan');
          var noteInput = document.getElementById('kw-note');
          if (nameInput) nameInput.value = saved.kahraman || '';
          if (hazInput)  hazInput.value  = saved.hazirlayan || '';
          if (noteInput) noteInput.value = saved.not || '';
          if (saved.cinsiyet) {
            var g = saved.cinsiyet === 'Kız' ? 'kiz' : 'erkek';
            var gEl = document.querySelector('#kw-gender .kw-opt[data-val="' + g + '"]');
            if (gEl) { gEl.classList.add('active'); gender = g; }
          }
          if (saved.iliski) {
            var savedParts = String(saved.iliski).split(' ve ');
            document.querySelectorAll('#kw-iliski .kw-chip').forEach(function(el){
              if (savedParts.indexOf(el.dataset.val) >= 0) { el.classList.add('active'); if(iliskiSel.indexOf(el.dataset.val)<0) iliskiSel.push(el.dataset.val); }
            });
            iliski = iliskiSel.join(' ve ');
          }
          // Restore uploaded URLs if present (so we don't re-upload)
          if (Array.isArray(saved.photoUrls) && saved.photoUrls.length >= 1) {
            photoUrls = saved.photoUrls.slice(0, 5);
            photos = photoUrls.map(function(){ return new File([new Uint8Array([0])],'_kept.jpg',{type:'image/jpeg'}); });
            var dz = document.getElementById('kw-photos');
            if (dz) dz.classList.add('has');
            var count = document.getElementById('kw-count');
            if (count) count.textContent = '(mevcut fotoğraflar korunacak)';
          }
          localStorage.removeItem('ms_wiz_edit_state');
          try { history.replaceState({}, '', location.pathname); } catch(_) {}
          setTimeout(function(){ if (window.msWizOpen) msWizOpen(); }, 400);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
        else hydrate();
      } else {
        localStorage.removeItem('ms_wiz_edit_state');
      }
    }
  }
} catch (e) { /* silent */ }

window.msWizOpen=function(){overlay.style.display='flex';step=0;goStep(0);
  var pop=document.getElementById('ms-popup-overlay');if(pop)pop.classList.remove('show');
};
window.msWizOpenForVariant=function(vid){
  var n=parseInt(vid,10);
  if(n&&!isNaN(n))variantId=n;
  window.msWizOpen();
};
window.msWizOpenPrefilled=function(vid,prefill){
  var n=parseInt(vid,10);
  if(n&&!isNaN(n))variantId=n;
  if(prefill){
    var nameInput=document.getElementById('kw-name');
    if(nameInput&&prefill.kahraman)nameInput.value=prefill.kahraman;
    if(prefill.cinsiyet){
      var g=prefill.cinsiyet==='Kız'?'kiz':(prefill.cinsiyet==='Erkek'?'erkek':'');
      if(g){
        document.querySelectorAll('#kw-gender .kw-opt').forEach(function(o){o.classList.remove('active')});
        var gEl=document.querySelector('#kw-gender .kw-opt[data-val="'+g+'"]');
        if(gEl){gEl.classList.add('active');gender=g;}
      }
    }
    var hazInput=document.getElementById('kw-hazirlayan');
    if(hazInput&&prefill.hazirlayan)hazInput.value=prefill.hazirlayan;
    if(prefill.iliski){
      var prefParts=String(prefill.iliski).split(' ve ');
      iliskiSel=[];
      document.querySelectorAll('#kw-iliski .kw-chip').forEach(function(el){
        el.classList.remove('active');
        if(prefParts.indexOf(el.dataset.val)>=0){el.classList.add('active');iliskiSel.push(el.dataset.val);}
      });
      iliski=iliskiSel.join(' ve ');
    }
    // Photos: if URLs provided, reuse. Else placeholder.
    if(Array.isArray(prefill.photoUrls)&&prefill.photoUrls.length>=1){
      photoUrls=prefill.photoUrls.slice(0,5);
      photos=photoUrls.map(function(){return new File([new Uint8Array([0])],'_kept.jpg',{type:'image/jpeg'})});
    } else {
      var placeholder=new File([new Uint8Array([0])],'_kept.jpg',{type:'image/jpeg'});
      photos=[placeholder,placeholder];
      photoUrls=[];
    }
    var dz=document.getElementById('kw-photos');
    if(dz)dz.classList.add('has');
    var countEl=document.getElementById('kw-count');
    if(countEl)countEl.textContent='(önceki kitaptaki fotoğraflar kullanılacak — istersen değiştir)';
  }
  window.msWizOpen();
};
window.msWizClose=function(){overlay.style.display='none'};
window.kwGender=function(el){
  document.querySelectorAll('#kw-gender .kw-opt').forEach(function(o){o.classList.remove('active')});
  el.classList.add('active');gender=el.dataset.val;kwCheck();
};
window.kwIliski=function(el){
  var val=el.dataset.val;
  var idx=iliskiSel.indexOf(val);
  if(idx>=0){ iliskiSel.splice(idx,1); el.classList.remove('active'); }
  else { if(iliskiSel.length>=2){ return; } iliskiSel.push(val); el.classList.add('active'); }
  iliski=iliskiSel.join(' ve ');
  // 2 ilişki seçilince "Hazırlayan"ı iyelikli otomatik doldur (kullanıcı düzenleyebilir)
  var haz=document.getElementById('kw-hazirlayan');
  if(haz){
    var suggest = iliskiSel.length===2 ? iliskiSel.map(function(r){return KW_POSS[r]||r;}).join(' ve ') : '';
    if(suggest && (haz.value.trim()==='' || haz.value===hazAuto)){ haz.value=suggest; hazAuto=suggest; }
    else if(!suggest && haz.value===hazAuto){ haz.value=''; hazAuto=''; }
  }
  kwCheck();
};

/* Client-side resize (canvas) to max 1600px longest edge, JPEG q=0.85.
   3-5 MB telefon fotoğrafını ~200-400 KB'a düşürür → upload 5-10x hızlanır. */
function resizeImage(file){
  return new Promise(function(resolve, reject){
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function(){
      var maxSide = 1600;
      var w = img.naturalWidth, h = img.naturalHeight;
      if (w > maxSide || h > maxSide) {
        if (w >= h) { h = Math.round(h * maxSide / w); w = maxSide; }
        else        { w = Math.round(w * maxSide / h); h = maxSide; }
      }
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob(function(blob){
        URL.revokeObjectURL(url);
        if (!blob) return reject(new Error('resize fail'));
        resolve(blob);
      }, 'image/jpeg', 0.85);
    };
    img.onerror = function(){ URL.revokeObjectURL(url); reject(new Error('img load fail')); };
    img.src = url;
  });
}

/* Upload single file to Cloudinary unsigned, return secure_url (with retries). */
function cloudinaryUpload(file){
  var endpoint = 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload';
  return resizeImage(file).catch(function(){ return file; }).then(function(blob){
    return new Promise(function(resolve, reject){
      var attempt = 0;
      function doFetch(){
        attempt++;
        var fd = new FormData();
        fd.append('upload_preset', CLOUDINARY_PRESET);
        fd.append('file', blob);
        fetch(endpoint, { method:'POST', body:fd })
          .then(function(r){ return r.json(); })
          .then(function(data){
            if (data && data.secure_url) resolve(data.secure_url);
            else if (attempt<3) setTimeout(doFetch, 1500);
            else reject(new Error('cloudinary fail: ' + (data && data.error && data.error.message || 'unknown')));
          })
          .catch(function(e){
            if (attempt<3) setTimeout(doFetch, 1500);
            else reject(e);
          });
      }
      doFetch();
    });
  });
}

window.kwPhotos=function(input){
  photos = Array.from(input.files).slice(0,5);
  photoUrls = []; // reset
  var t = document.getElementById('kw-thumbs'); t.innerHTML='';
  var countEl = document.getElementById('kw-count');
  photos.forEach(function(f){
    var i=document.createElement('img');
    i.src=URL.createObjectURL(f);
    t.appendChild(i);
  });
  document.getElementById('kw-photos').classList.toggle('has', photos.length>0);
  if (photos.length===0){ if(countEl)countEl.textContent=''; kwCheck(); return; }
  if(countEl)countEl.textContent = 'Yükleniyor 0/'+photos.length+'...';
  uploadingCount = photos.length;
  // Parallel upload to Cloudinary (no rate limit issue like imgbb)
  var done = 0;
  photoUrls = new Array(photos.length);
  var tasks = photos.map(function(f, i){
    return cloudinaryUpload(f).then(function(url){
      photoUrls[i] = url;
      done++;
      if(countEl)countEl.textContent = 'Yükleniyor '+done+'/'+photos.length+'...';
      kwCheck();
    });
  });
  Promise.all(tasks).then(function(){
    if(countEl){countEl.textContent = photos.length+' fotoğraf yüklendi ✓'; countEl.style.color='';}
    uploadingCount = 0;
    kwCheck();
  }).catch(function(err){
    if(countEl){countEl.textContent='Hata — fotoğrafı tekrar seç'; countEl.style.color='#e74c3c';}
    uploadingCount = 0;
    photoUrls = [];
    document.getElementById('kw-photos').classList.remove('has');
    kwCheck();
  });
};
window.kwCheck=function(){
  var ok=false;
  if(step===0) ok = document.getElementById('kw-name').value.trim().length>0;
  if(step===1) ok = !!gender; // Yaş kaldırıldı
  if(step===2) ok = photos.length>=1 && photoUrls.length>=1 && uploadingCount===0;
  if(step===3) ok = document.getElementById('kw-hazirlayan').value.trim().length>0 && !!iliski;
  var nb=document.getElementById('kw-next');
  nb.disabled = !ok;
  nb.style.opacity = ok ? '1' : '0.3';
  document.getElementById('kw-err').style.display='none';
};
function goStep(s){
  step=s;
  steps.forEach(function(el,i){el.classList.toggle('active',i===s)});
  dots.forEach(function(d,i){
    if(i<s){d.style.background='var(--ms-orange)';d.classList.remove('active');}
    else if(i===s){d.style.background='';d.classList.add('active');}
    else{d.style.background='#e8e2da';d.classList.remove('active');}
  });
  document.getElementById('kw-back').style.display = s>0 ? 'block' : 'none';
  document.getElementById('kw-next').textContent = s===LAST_STEP ? '✨ Sepete Ekle' : 'Devam →';
  kwCheck();
}
window.kwNext=function(){
  if(document.getElementById('kw-next').disabled)return;
  if(step<LAST_STEP){goStep(step+1);return}
  var name=document.getElementById('kw-name').value.trim();
  var hazirlayan=document.getElementById('kw-hazirlayan').value.trim();
  if(!name || !gender || photoUrls.length<1 || !hazirlayan || !iliski){
    document.getElementById('kw-err').textContent='Tüm alanları doldurun (en az 1 fotoğraf yüklenmiş olmalı)';
    document.getElementById('kw-err').style.display='block';return;
  }
  var properties = {
    'Kahraman': name,
    'Cinsiyet': gender==='kiz' ? 'Kız' : 'Erkek',
    'Fotoğraf 1': photoUrls[0],
    'Hazırlayan': hazirlayan,
    'İlişki': iliski
  };
  if (photoUrls[1]) properties['Fotoğraf 2'] = photoUrls[1];
  if (photoUrls[2]) properties['Fotoğraf 3'] = photoUrls[2];
  if (photoUrls[3]) properties['Fotoğraf 4'] = photoUrls[3];
  if (photoUrls[4]) properties['Fotoğraf 5'] = photoUrls[4];
  var body={items:[{id:variantId,quantity:1,properties:properties}]};
  document.getElementById('kw-next').textContent=editLineKey?'Güncelleniyor...':'Ekleniyor...';
  document.getElementById('kw-next').disabled=true;
  /* 11 Eki: 2xx dışı yanıtta (422 stok/429 yoğunluk vb.) sepete gitmeden sihirbazda hata göster; 429'da bir kez tekrar dene.
     Düzenleme modunda eski satır yalnız ekleme başarılıysa silinir. */
  function kwAdd(retried){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
    .then(function(r){
      if (r.ok) return r.json();
      if (r.status===429 && !retried) return new Promise(function(res){ setTimeout(res,1500); }).then(function(){ return kwAdd(true); });
      return r.json().catch(function(){ return {}; }).then(function(j){
        var msg=(j && (j.description || j.message)) || '';
        throw new Error(msg ? msg : 'Sepete eklenemedi, lütfen tekrar deneyin.');
      });
    });
  }
  kwAdd(false)
  .then(function(){
    if (editLineKey) {
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:editLineKey,quantity:0})})
        .then(function(){ window.location.href='/cart'; });
    }
    window.location.href='/cart';
  })
  .catch(function(e){
    var ke=document.getElementById('kw-err');
    ke.textContent=(e && e.message) ? e.message : 'Sepete eklenemedi, lütfen tekrar deneyin.';
    ke.style.display='block';
    try { ke.scrollIntoView({block:'center',behavior:'smooth'}); } catch(_) {}
    document.getElementById('kw-next').textContent='✨ Sepete Ekle';
    document.getElementById('kw-next').disabled=false;
  });
};
window.kwPrev=function(){if(step>0)goStep(step-1)};
overlay.addEventListener('click',function(e){if(e.target===overlay)msWizClose()});

function replaceButtons(){
  if(!document.querySelector('.product-information'))return;var addBtn=document.querySelector('button[name="add"]');
  if(addBtn&&!addBtn._msReplaced){
    addBtn._msReplaced=true;
    var newBtn=document.createElement('button');
    newBtn.textContent='✨ Kişiselleştir ve Sepete Ekle';
    newBtn.style.cssText='width:100%;padding:14px;background:var(--ms-orange);color:#fff;border:none;border-radius:12px;font-family:Nunito,sans-serif;font-size:15px;font-weight:800;cursor:pointer;margin-top:8px';
    newBtn.addEventListener('click',function(e){e.preventDefault();msWizOpen()});
    addBtn.style.display='none';
    addBtn.parentNode.insertBefore(newBtn,addBtn.nextSibling);
    if(!window.__msStickyIO){
      window.__msStickyIO=true;
      var stickyBar=document.getElementById('ms-new-sticky');
      if(stickyBar){
        stickyBar.style.transition='transform 0.3s ease,opacity 0.3s ease';
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){stickyBar.style.transform='translateY(100%)';stickyBar.style.opacity='0';stickyBar.style.pointerEvents='none'}
            else{stickyBar.style.transform='translateY(0)';stickyBar.style.opacity='1';stickyBar.style.pointerEvents='auto'}
          });
        },{threshold:0}).observe(newBtn);
      }
    }
  }
}
replaceButtons();
new MutationObserver(replaceButtons).observe(document.body,{childList:true,subtree:true});

document.addEventListener('click',function(e){
  if(!document.querySelector('.product-information'))return;
  var sticky=e.target.closest('.sticky-add-to-cart__button');
  if(sticky){
    e.preventDefault();
    e.stopPropagation();
    if(window.msWizOpen)window.msWizOpen();
  }
},true);
})();
